import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import Dashboard from "@/pages/Dashboard";
import Calculator from "@/pages/Calculator";
import Bar168Simulator from "@/pages/Bar168Simulator";
import LoginPage from "@/pages/LoginPage";
import AuthCallback from "@/pages/AuthCallback";
import Navbar from "@/components/Navbar";
import { AuthProvider } from "@/lib/auth";

function AppRouter() {
  const location = useLocation();
  // Detect session_id during render (NOT in useEffect) — prevents race conditions
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <>
      <Navbar />
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/" element={<Dashboard />} />
        <Route path="/calculator" element={<Calculator />} />
        <Route path="/calculator/:id" element={<Calculator />} />
        <Route path="/168" element={<Bar168Simulator />} />
      </Routes>
    </>
  );
}

function App() {
  return (
    <div className="App min-h-screen">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
          <Toaster richColors position="top-right" />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
